import { defineMessages } from 'react-intl';

export default defineMessages({
  403: {
    id: 'baukasten.ErrorState.403',
    defaultMessage: 'You do not have permission to access the {entity}.',
  },
  404: {
    id: 'baukasten.ErrorState.404',
    defaultMessage: '{entity} not found.',
  },
});
